export const environment = {
  production: true,
  backendurl: 'https://resumex.io:4430',
  stripeKey: "pk_test_GhuLqvF7bjM8KDm0OdmqeZTp"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts